import { render, staticRenderFns } from "./AddCredentialsCard.vue?vue&type=template&id=84c04990&scoped=true"
import script from "./AddCredentialsCard.vue?vue&type=script&lang=js"
export * from "./AddCredentialsCard.vue?vue&type=script&lang=js"
import style0 from "./AddCredentialsCard.vue?vue&type=style&index=0&id=84c04990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c04990",
  null
  
)

export default component.exports